import { Injectable } from "@angular/core";
import { ApiService } from "@meddatacore/common";
import { EnumModel } from "../../models/enum.model";
@Injectable({ providedIn: "root" })
export class EnumApiService extends ApiService {
  private endPoint = '/api/enums';
  get(name: string) {
    return this.http.get<EnumModel[]>(`${this.commonBaseURL}${this.endPoint}/${name}`);
  }
}
